
import { useEffect, useRef } from 'react';

/**
 * Simplified polling hook with all polling disabled
 */
export const useAdminRealtime = (
  usingSupabase: boolean,
  refreshFunction: () => void
) => {
  // No polling mechanism - all polling completely disabled
  
  useEffect(() => {
    console.log('Automatic polling completely disabled - NO automatic refreshes');
    
    // No polling setup - intentionally empty
    
    return () => {
      // No cleanup needed
    };
  }, [usingSupabase, refreshFunction]);
};
